export default "/images/tips.svg?ba4196eed5e5be785b6413ee86be612c";